import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Select from 'react-select'

const ModalNewCase = ({ handleColse, editData = null, getDepartment }) => {
     const link = `https://www.ismbonline.org/registrationTrainingDays?pId=${editData?.id}`;
    const GET_URL = 'admin/qualification/create_package'
    const GET_UPDATA = `admin/qualification/packages/${editData?.id}`
    const GET_Filter = 'admin/qualification/init_package_qul_ids'
    const [datafiler, setDatafiler] = useState([]);
     const [copied, setCopied] = useState(false);
    const [formData, setFormData] = useState({
        packImage: "",
        name: "",
        number: "",
        area: null,
        // qualificationDays:[]
    })

    const [file, setFile] = useState(null)
    const [errors, setErrors] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedIds, setSelectedIds] = useState([]);

    const handleChange = (selectedOption, name) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption?.value || null,
        }));
    };

    const handleCheck = (itemId) => {
        setSelectedIds((prev) =>
            prev.includes(itemId)
                ? prev.filter((id) => id !== itemId)
                : [...prev, itemId]
        );
        if (errors?.selectedIds) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors["selectedIds"];
                return newErrors;
            });
        }
        // console.log(selectedIds)
    };


     const handleCopy = () => {
        navigator.clipboard.writeText(link).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // מחיקת ההודעה אחרי 2 שניות
        }).catch(err => console.error("שגיאה בהעתקה:", err));
      };

    const filteredItems = datafiler?.filter((item) => {
        // אם כל התווים הם ספרות — חיפוש לפי מספר
        if (/^\d+$/.test(searchTerm)) {
            return item.number.toString().includes(searchTerm);
            // return item.number.includes(searchTerm);
        }
        // אחרת — חיפוש לפי שם
        return item.name.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const handleChangetext = (e) => {
        console.log(e.target)
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        };
    }



    const handleFileChange = (event) => {
        // const { name } = event.target;
        const fileInput = event.target;
        const file1 = fileInput.files[0];


        if (file1) {
            setFile(file1)
            // נקה את התמונה הקודמת
            setFormData((prevFormData) => ({
                ...prevFormData,
                "packImage": null, // נקה קודם
            }));

            const reader = new FileReader();

            reader.onload = (e) => {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    "packImage": e.target.result, // עדכן את התמונה החדשה
                }));
            };
            if (errors[fileInput?.name]) {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[fileInput?.name];
                    return newErrors;
                });
            }
            reader.readAsDataURL(file1);
            fileInput.value = '';
        }
    };
    //     const handleFileChange = (e) => {
    //   const file = e.target.files[0];
    //   if (file) {
    //     setFile(file);
    //     const imageUrl = URL.createObjectURL(file);
    //     setFormData(prev => ({
    //       ...prev,
    //       packImage: imageUrl
    //     }));
    //   }
    // };
    // const handleEmployeeSelection = useCallback((employeeId) => {
    //     setSelectedEmployees((prev) =>
    //         prev.includes(employeeId) ? prev.filter((id) => id !== employeeId) : [...prev, employeeId]
    //     );
    // }, []);


    const validate = () => {
        const errors = {};
        if (!formData.name) errors.name = "יש להזין שם מארז";
        if (!formData.number) errors.number = "יש להזין מספר מארז";
        if (!editData && !file) errors.packImage = "יש להעלות תמונה";
        if (selectedIds.length == 0) errors.selectedIds = "יש לבחור ימי כשירות";
        return errors;
    };

    const addNewCase = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        let formData1 = new FormData();
        formData1.append('reqPack', JSON.stringify({ "name": formData?.name, "number": formData?.number, "qualificationDays": selectedIds, "area": formData?.area || null }
        ));
        formData1.append('packImage', file);
        console.log(formData)
        console.log(selectedIds)
        let response
        if (editData) {
            response = await axios.put(GET_UPDATA, formData1

                ,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
        }
        else {
            response = await axios.post(GET_URL, formData1

                ,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
        }
        console.log(response)
        if (response?.status == 200) {
            // setnamecalss("")
            editData ? toast.success("המארז עודכן",
                //                 {
                //   style: {
                //     fontSize: "20px", // גודל הכיתוב
                //     padding: "16px",
                //   },
                // }
            ) : toast.success("המארז התווסף",
                //     {
                //   style: {
                //     fontSize: "20px", // גודל הכיתוב
                //     padding: "16px",
                //   },
                // }
            );
            getDepartment()
            handleColse()
        }
        else {
            console.log("error add case")
        }
    }




    useEffect(() => {
        const getFilter = async () => {

            await axios.get(GET_Filter, {
            })
                .then(response => {
                    setDatafiler(response?.data)

                })

        }
        getFilter()

        if (editData) {
            setFormData({
                // reqPack: {
                name: editData.name,
                number: editData.number,
                packImage: "",
                area: editData.area || null,
                // },
                // packImage: editData.linkImage ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${editData?.linkImage}` : "", // נניח שזו תמונה כ-URL
            });
            setSelectedIds(editData.qualificationDays || []);
        }

    }

        , [])
    return (
        <div className=' fixed top-0 bottom-0 right-0 left-0 flex flex-col items-center py-4 w-full min-h-screen drop-shadow-2xl shadow-2xl bg-slate-600/80 overflow-y-auto'>
            <div className='bg-white w-[60%] rounded-lg divide-y-2  divide-slate-500 border-0 border-emerald-50 '>
                <div className='w-full bg-[#0d406b] rounded-t-md flex justify-end border-[#0d406b] border-2'>
                    <button className='p-1 px-2 m-3 border bg-blue-700 hover:bg-blue-500' onClick={() => {
                        handleColse()
                    }} >x</button>
                </div>



                <form className='w-full p-5 flex flex-col  text-center text-sm'>

                    <div className="w-full pt-2 flex justify-end">

                        <input
                            className='border w-1/2 text-right'
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="name" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>שם המארז</p></label>

                    </div>
                    {/* {errors.name && <span className="error">{errors.name}</span>} */}
                    {errors.name && <span className="text-red-500 text-sm">{errors.name}</span>}
                    <div className='w-full pt-2 flex justify-end'>

                        <input
                            className='border w-1/2 text-right'
                            type="number"
                            id="number"
                            name="number"
                            value={formData.number}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="number" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>מספר מארז</p></label>

                    </div>
                    {errors.number && <span className="text-red-500 text-sm">{errors.number}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <Select
                            className=' w-1/2 border text-right'
                            placeholder="בחר אזור"
                            isClearable
                            isSearchable
                            id="area"
                            name="area"
                            options={[
                                { value: 'צפון', label: 'צפון' },
                                { value: 'מרכז', label: 'מרכז' },
                                { value: 'דרום', label: 'דרום' },
                            ]}
                            value={formData.area ? { value: formData.area, label: formData.area } : null}
                            onChange={(e) => handleChange(e, 'area')}
                            maxMenuHeight={150}
                        />
                        <label htmlFor="area" className='w-[30%] font-semibold'><p className='ml-2'>אזור</p></label>
                    </div>




                    {/* 
                    <div className="w-full pt-2 flex justify-end">

                        <input
                            className='border w-1/2 h-fit '
                            type="file"
                            accept='image/png,image/jpeg'
                            id="urlimage"
                            name="urlimage"
                            // value={formData?.urlimage}
                            onChange={handleFileChange}
                        />
                        <label htmlFor="urlimage" className='w-[30%]'><p className='ml-2'><span className='text-red-600'>*</span>תמונה של המארז </p></label>

                    </div> */}
                    {/* {<img className='w-[160px] h-[160px]  object-cover m-4 mb-0 flex self-end' src={formData?.frame_imgSignature_url || } />} */}
                    {/* {<img className='w-[200px] h-[200px] object-cover m-4 mb-0 flex self-center'
                    key={formData.packImage || editData?.linkImage}
                    src={formData?.packImage? formData?.packImage: editData?.linkImage ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${editData?.linkImage}` : ""} // ודא שאין שגיאה אם `urlimage` לא קיים
                    />} */}



                    <div className="w-full flex flex-col items-end gap-2 pt-4">
                        <label htmlFor="urlimage" className="w-[30%] text-center text-sm font-semibold">
                            <span className="text-red-600">*</span> תמונה של המארז
                        </label>

                        {formData.packImage || editData?.linkImage ? (
                            <div className="relative w-[200px] h-[200px] flex self-center" >
                                <img
                                    src={formData.packImage || `https://archivebureau.s3.eu-west-3.amazonaws.com/${editData?.linkImage}`}
                                    alt="תמונה של המארז"
                                    className="w-full h-full object-cover rounded-lg border shadow"
                                />
                                <label
                                    htmlFor="packImage"
                                    className="absolute bottom-2 right-2 bg-white bg-opacity-80 px-3 py-1 text-sm border border-gray-300 rounded cursor-pointer hover:bg-opacity-100 transition"
                                >
                                    שנה תמונה
                                </label>
                            </div>
                        ) : (
                            <label
                                htmlFor="packImage"
                                className="flex items-center justify-center self-center w-1/2 h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition"
                            >
                                <span className="text-gray-500 text-sm">לחץ כאן להעלאת תמונה</span>
                            </label>
                        )}

                        <input
                            id="packImage"
                            name="packImage"
                            type="file"
                            accept="image/png,image/jpeg"
                            onChange={handleFileChange}
                            className="hidden"
                        />
                    </div>



                    {/* <input
                        type="text"
                        placeholder="חפש לפי שם..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-3 py-2 border rounded"
                    /> */}

                    {/* <div className="border p-2 rounded-lg max-h-60 overflow-y-auto">
                        {arr.map((ar) => (
                            <label key={ar.id} className="flex items-center gap-2 p-1">
                                <input
                                    type="checkbox"
                                    className="w-4 h-4"
                                    checked={selectedEmployees.includes(ar.id)}
                                    onChange={() => handleEmployeeSelection(ar.id)}
                                />
                                {`${ar.name} ${ar.number}`}
                            </label>))}
                    </div> */}
                    {errors.packImage && <span className="text-red-500 text-sm">{errors.packImage}</span>}
                    <div className="p-4 mt-2 border rounded-lg w-full max-w-xl mx-auto space-y-4" style={{ direction: "rtl" }}>
                        <input
                            type="text"
                            placeholder="חפש לפי שם..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full px-3 py-2 border rounded"
                        />

                        <div className="space-y-2 max-h-64 overflow-y-auto">
                            {(searchTerm === "" ? datafiler : filteredItems).map((item) => (
                                <label key={item.id} className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.includes(item.id)}
                                        onChange={() => handleCheck(item.id)}
                                    />
                                    <span>{item.name}</span>
                                </label>
                            ))}

                            {(searchTerm !== "" && filteredItems.length === 0) && (
                                <p className="text-sm text-gray-500 text-center">לא נמצאו תוצאות</p>
                            )}
                        </div>
                        {/* {errors.selectedIds && <span className="text-red-500 text-sm">{errors.selectedIds}</span>} */}

                    </div>

                    {errors?.selectedIds && <span className="text-red-500 text-sm">{errors?.selectedIds}</span>}
                </form>
                {editData?.id && <div className='grid grid-cols-10 items-center'dir='rtl' >
                    <div className='col-span-3 font-bold text-gray-700' >קישור למארז</div>
                    <div className='col-span-4 text-center p-2 text-gray-900 border' >{link} </div>
                    <button
                        onClick={handleCopy}
                        className="col-span-1 bg-blue-500 mr-2 text-white px-2 py-2 rounded hover:bg-blue-600 transition"
                    >
                        {copied ? "📋 הועתק!" : "📋 העתק"}
                    </button>
                </div>}
                <div className='w-full p-2   flex justify-end'>
                    <button className='border bg-green-500 hover:bg-green-300 p-1 px-3' onClick={() => {
                        addNewCase()


                    }}>שמור</button>
                    <button className='border bg-slate-700 hover:bg-slate-500 p-1 px-3' onClick={() => {

                        handleColse()
                    }}>בטל</button>
                </div>
            </div>

        </div>
    )
}

export default ModalNewCase